module.exports = __webpack_public_path__ + "img/drone.26d34789.png";